import { render, staticRenderFns } from "./TpmSpindleDataTsdList.vue?vue&type=template&id=10f40a20&scoped=true&"
import script from "./TpmSpindleDataTsdList.vue?vue&type=script&lang=js&"
export * from "./TpmSpindleDataTsdList.vue?vue&type=script&lang=js&"
import style0 from "./TpmSpindleDataTsdList.vue?vue&type=style&index=0&id=10f40a20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f40a20",
  null
  
)

export default component.exports